<template>
    <div class="animated fadeIn">
        <vue-loading :active="isLoading" loader="bars" :is-full-page="false"></vue-loading>
        <b-form>
            <b-form-group
                    description="Enter the person name."
                    label="Person name"
                    :label-cols="3"
                    :horizontal="true">
              <b-form-input v-model="person.name" type="text" autocomplete="name"></b-form-input>
              <validation-errors :errors="person.errors" field="name"></validation-errors>
            </b-form-group>
            <b-form-group
                    description="Enter the person surname."
                    label="Person surname"
                    :label-cols="3"
                    :horizontal="true">
                <b-form-input v-model="person.surname" type="text" autocomplete="surname"></b-form-input>
            </b-form-group>
            <b-form-group
                    description="Enter the person email."
                    label="Person email"
                    :label-cols="3"
                    :horizontal="true">
              <b-form-input v-model="person.email" type="text" autocomplete="email" required></b-form-input>
              <validation-errors :errors="person.errors" field="email"></validation-errors>
            </b-form-group>
            <b-form-group
                    description="Enter the person type."
                    label="Person Type"
                    :label-cols="3"
                    :horizontal="true">
                <b-form-select v-model="person.type" :options="personTypes" required></b-form-select>
              <validation-errors :errors="person.errors" field="type"></validation-errors>
            </b-form-group>
            <b-form-group
                    description="Enter the person mobile."
                    label="Person mobile"
                    :label-cols="3"
                    :horizontal="true">
                <b-form-input v-model="person.mobile" type="text" autocomplete="mobile"></b-form-input>
              <validation-errors :errors="person.errors" field="mobile"></validation-errors>
            </b-form-group>
            <b-form-group
                    description="Enter the person locality."
                    label="Person Locality"
                    :label-cols="3"
                    :horizontal="true">
                <b-form-input v-model="person.locality" type="text" autocomplete="locality"></b-form-input>
            </b-form-group>
            <b-form-group
                    description="Enter the person address."
                    label="Person Address"
                    :label-cols="3"
                    :horizontal="true">
                <b-form-input v-model="person.address" type="text" autocomplete="address"></b-form-input>
            </b-form-group>
            <div slot="footer">
                <b-button
                  type="button"
                  size="sm" variant="primary"
                  v-on:click="savePerson"
                  v-if="editOption"
                ><i class="fa fa-dot-circle-o" ></i>Save
                </b-button>
              <person-add-button
                v-if="addOption"
                :person="person"
                :disabled="validationPassed"
                @click="onBtnClick"
              ></person-add-button>
            </div>
        </b-form>
    </div>
</template>
<script>
    import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
    import {Person} from "../../models/Person";
    import {parseEnum, handleErrors} from "../../shared/utils";
    import VueLoading from "vue-loading-overlay/src/js/Component";
    import PersonAddButton from "./Buttons/PersonAddButton";
    import ValidationErrors from "../base/ValidationErrors";

    const PeopleRepo = RepositoryFactory.get('people')

    export default {
        name: 'person-form',
        components: {
            PersonAddButton,
            VueLoading,
            ValidationErrors,
        },
        props: {
            person: {
                type: Person,
                default: new Person()
            },
            addOption: {
                type: Boolean,
                default: false,
            },
            editOption: {
                type: Boolean,
                default: false,
            },
        },
        data: () => {
            return {
                personTypes: parseEnum(Person.TYPES),
                isLoading: false,
                validationPassed: false,
            }
        },
        methods: {
            savePerson () {
                this.isLoading = true
                PeopleRepo
                    .updatePerson(this.person.id, this.person)
                    .then(
                        response => (
                            this.isLoading = false,
                            this.flash('Person has been updated', 'success'),
                            this.$emit('input', response.data.data)
                        )
                    )
                    .catch(
                        error => (
                            this.returnErrors(error)
                        ),
                    )
            },
            returnErrors(errors) {
                handleErrors(errors).forEach(
                    value => {
                        this.flash(value, 'error')
                    }
                )
                this.isLoading = false
            },
            onBtnClick(){
                this.isLoading = this.isLoading ? false : true
            },
        },
        watch: {
            'person.errors': {
                handler(errors) {
                    let keys = Object.keys(errors)
                    if (keys.length >= 1) {
                        this.validationPassed = true
                        return
                    }
                    this.validationPassed = false
                }
            }
        }
    }
</script>
